module.exports = __webpack_public_path__ + "static/img/da3.2b936d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/da3.png
// module id = eebN
// module chunks = 1